<template>
  <gj-table
      ref="gjTable"
      v-bind="$attrs"
      v-on="$listeners"
      :scroll-x="{gt: 0, enabled: true, oSize: 40}"
      :scroll-y="{gt: 0, enabled: true}"
      :show-summary="showSummary">

    <template v-slot:header:Sessions>
      Sessions
      <gj-help>
        <div>数据来源：插件—亚马逊业务报告（按日期）</div>
        <div>字段：sessions</div>
        <div>使用说明：单天查询直接取当天数据，多天查询取数据之和</div>
      </gj-help>
    </template>
    <template v-slot:header:PV>
      PV
      <gj-help>
        <div>数据来源：插件—亚马逊业务报告（按日期）</div>
        <div>字段：pv</div>
        <div>使用说明：单天查询直接取当天数据，多天查询取数据之和</div>
      </gj-help>
    </template>
    <template v-slot:header:BuyBox>
      buybox
      <gj-help>
        <div>数据来源：插件—亚马逊业务报告（按日期）</div>
        <div>字段：buybox</div>
        <div>使用说明：单天查询直接取当天数据，多天查询取数据之和/天数</div>
      </gj-help>
    </template>
    <template v-slot:header:CVR>
      CVR
      <gj-help>
        <div>字段释义：订单转化率</div>
        <div>数据来源：自计算</div>
        <div>计算公式：总销量/sessions</div>
        <div>使用说明：单天查询直接取当天数据相除，多天查询取数据之和相除</div>
      </gj-help>
    </template>

    <!--        Sessions-->
    <template v-slot:sessionsMobile="{ row }">
      <div class="flex align-center justify-center">
        <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
              <span class="trafficError" @click="handleClickColumn(row, 'sessionsMobile')">
                {{ row.sessionsMobile | defaultShow }}
              </span>
        </gj-tooltip>
        <!-- <span v-else>
               {{ row.sessionsMobile | defaultShow }}
              </span> -->
        <DataClickView v-else @dataClick="handleClickColumn(row, 'sessionsMobile')" :text="row.sessionsMobile | defaultShow"/>
      </div>
    </template>
    <template v-slot:sessionsBrowser="{ row }">
      <div class="flex align-center justify-center">
        <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
              <span class="trafficError"  @click="handleClickColumn(row, 'sessionsBrowser')">
                {{ row.sessionsBrowser | defaultShow }}
              </span>
        </gj-tooltip>
        <DataClickView v-else @dataClick="handleClickColumn(row, 'sessionsBrowser')" :text="row.sessionsBrowser | defaultShow"/>
        <!-- <span v-else>
               {{ row.sessionsBrowser | defaultShow }}
              </span> -->
      </div>
    </template>
    <template v-slot:sessions="{ row }">
      <div class="flex align-center justify-center">
        <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
              <span class="trafficError" @click="handleClickColumn(row, 'sessions')">
                {{ row.sessions | defaultShow }}
              </span>
        </gj-tooltip>
        <DataClickView v-else @dataClick="handleClickColumn(row, 'sessions')" :text="row.sessions | defaultShow"/>
        <!-- <span v-else>
               {{ row.sessions | defaultShow }}
              </span> -->
        <!-- <el-popover
            style="padding: 0;margin-left: 6px;"
            popper-class="no-padding-poppers"
            trigger="click"
            placement="bottom"
            @hide="chartLoading = true"
            @after-enter="handRankingChart(row,'sessions')"
        >
          <StatisticsChart v-loading="chartLoading" :chartData="chartData" :group-type="sessionsGroupType"  :type="type"/>
          <gj-icon
              slot="reference"
              class="analysis-icon"
              iconfont="iconshuju">
          </gj-icon>
        </el-popover> -->
      </div>
    </template>
    <!--        CVR-->
    <template v-slot:unitSessionPercentage="{ row }">
      <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
              <span class="trafficError" @click="handleClickColumn(row, 'unitSessionPercentage')">
               {{ row.unitSessionPercentage | defaultShow('','%') }}
              </span>
      </gj-tooltip>
      <DataClickView v-else @dataClick="handleClickColumn(row, 'unitSessionPercentage')" :text="row.unitSessionPercentage | defaultShow('','%')"/>
      <!-- <span v-else>
               {{ row.unitSessionPercentage | defaultShow('','%') }}
              </span>
      <el-popover
          style="padding: 0;margin-left: 6px;"
          popper-class="no-padding-poppers"
          trigger="click"
          placement="bottom"
          @hide="chartLoading = true"
          @after-enter="handRankingChart(row,'cvr')"
      >
        <StatisticsChart v-loading="chartLoading" :chartData="chartData" :type="type"/>
        <gj-icon
            slot="reference"
            class="analysis-icon"
            iconfont="iconshuju">
        </gj-icon>
      </el-popover> -->
    </template>
    <!--        PV-->
    <template v-slot:pageViewsMobile="{ row }">
      <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
              <span class="trafficError" @click="handleClickColumn(row, 'pageViewsMobile')">
                {{ row.pageViewsMobile | defaultShow }}
              </span>
      </gj-tooltip>
      <DataClickView v-else @dataClick="handleClickColumn(row, 'pageViewsMobile')" :text="row.pageViewsMobile | defaultShow"/>
      <!-- <span v-else>
               {{ row.pageViewsMobile | defaultShow }}
              </span> -->
    </template>
    <template v-slot:pageViewsBrowser="{ row }">
      <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
              <span class="trafficError" @click="handleClickColumn(row, 'pageViewsBrowser')">
                {{ row.pageViewsBrowser | defaultShow }}
              </span>
      </gj-tooltip>
      <DataClickView v-else @dataClick="handleClickColumn(row, 'pageViewsBrowser')" :text="row.pageViewsBrowser | defaultShow"/>
      <!-- <span v-else>
               {{ row.pageViewsBrowser | defaultShow }}
              </span> -->
    </template>
    <template v-slot:pageViews="{ row }">
      <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
              <span class="trafficError" @click="handleClickColumn(row, 'pageViews')">
                {{ row.pageViews | defaultShow }}
              </span>
      </gj-tooltip>
      <DataClickView v-else @dataClick="handleClickColumn(row, 'pageViews')" :text="row.pageViews | defaultShow"/>
      <!-- <span v-else>
               {{ row.pageViews | defaultShow }}
              </span> -->
      <!-- <el-popover
          style="padding: 0;margin-left: 6px;"
          popper-class="no-padding-poppers"
          trigger="click"
          placement="bottom"
          @hide="chartLoading = true"
          @after-enter="handRankingChart(row,'pv')"
      >
        <StatisticsChart v-loading="chartLoading" :chartData="chartData" :group-type="pvGroupType" :type="type"/>
        <gj-icon
            slot="reference"
            class="analysis-icon"
            iconfont="iconshuju">
        </gj-icon>
      </el-popover> -->
    </template>
    <!--        BuyBox-->
    <template v-slot:buyBoxPercentage="{ row }">
      <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
              <span class="trafficError" @click="handleClickColumn(row, 'buyBoxPercentage')">
              {{ row.buyBoxPercentage | defaultShow('','%') }}
              </span>
      </gj-tooltip>
      <DataClickView v-else @dataClick="handleClickColumn(row, 'buyBoxPercentage')" :text="row.buyBoxPercentage | defaultShow('','%')"/>
      <!-- <span v-else>
              {{ row.buyBoxPercentage | defaultShow('','%') }}
              </span>
      <el-popover
          style="padding: 0;margin-left: 6px;"
          popper-class="no-padding-poppers"
          trigger="click"
          placement="bottom"
          @hide="chartLoading = true"
          @after-enter="handRankingChart(row,'buybox')"
      >
        <StatisticsChart v-loading="chartLoading" :chartData="chartData" :type="type"/>
        <gj-icon
            slot="reference"
            class="analysis-icon"
            iconfont="iconshuju">
        </gj-icon>
      </el-popover> -->
    </template>

    <template v-slot:analysis="{row}">
      <gj-button
          type="text"
          @click="opListingAnalysis(row)"
          style="font-size: 21px;">
        <gj-icon iconfont="iconshuju1" class="analysis-icon"></gj-icon>
      </gj-button>
      <span v-if="false" @click="opListingAnalysis">
        <gj-icon iconfont="iconshuju" class="analysis-icon"></gj-icon>
      </span>
    </template>
    <template v-slot:header:listingInfo>
      <span v-if="groupType === 'asin'">ASIN/售价</span>
      <span v-else-if="groupType === 'variationAsin'">父ASIN/售价</span>
      <span v-else-if="groupType === 'msku'">MSKU/ASIN</span>
    </template>
    <template v-slot:listingInfo="{row}">
      <template v-if="groupType === 'asin'">
        <div>
          <gj-text>
            <gj-link :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
          </gj-text>
        </div>
        <div>{{row.salePrice | defaultShow(row.currencySymbol)}}</div>
      </template>
      <template v-else-if="groupType === 'variationAsin'">
        <div>
          <gj-text>
            <gj-link v-if="row.parent" :href="row.variationAsinUrl" target="_blank">{{row.variationAsin | defaultShow}}</gj-link>
            <gj-link v-else :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
          </gj-text>
        </div>
        <div>{{row.salePrice | defaultShow(row.currencySymbol)}}</div>
      </template>
      <template v-else-if="groupType === 'msku'">
        <el-row type="flex">
          <gj-text max-width="90%">{{row.msku | defaultShow}}</gj-text>
          <gj-copy-icon :content="row.msku"></gj-copy-icon>
        </el-row>
        <el-row type="flex">
          <gj-text max-width="90%">
            <gj-link :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
          </gj-text>
          <gj-copy-icon :content="row.asin"></gj-copy-icon>
        </el-row>
      </template>
    </template>
    <template v-slot:asins="{row}">
      <gj-icon
          iconfont="iconshuju1"
          class="analysis-icon"
          @click.native="handleNavigateAsin(row)"
      ></gj-icon>
    </template>
    <template v-slot:listingMarketName="{row}">
      <template v-if="groupType === 'asin' || groupType === 'variationAsin'">
        <template v-if="row.parent && row.items && row.items.length > 1">{{row.country | defaultShow}}</template>
        <template v-else>{{row.marketName | defaultShow}}</template>
      </template>
      <template v-else>
        {{row.marketName | defaultShow}}
      </template>
    </template>
    <template v-slot:marketAnalysis="{row}">
      <gj-icon
          iconfont="iconshuju1"
          class="analysis-icon"
          @click.native="handleNavigateMarket(row)"
      ></gj-icon>
    </template>
    <template v-slot:product="{row}">
      <gj-text width="100%">{{row.skuName | defaultShow}}</gj-text>
      <el-row type="flex">
        <template v-if="row.sku">
          <gj-popover-panel
              v-if="row.marketSkuList && row.marketSkuList.length > 1"
              placement="right"
              :width="'250px'"
              :data="row.marketSkuList">
            <gj-text max-width="90%">{{row.sku | defaultShow}}</gj-text>
          </gj-popover-panel>
          <template v-else>{{row.sku | defaultShow}}</template>
        </template>
        <template v-else>-</template>
      </el-row>
    </template>
    <template v-slot:skuNameAndSku="{row}">
      <template v-if="row.parent">
        <el-row type="flex">
          <gj-text max-width="90%">{{row.skuName | defaultShow}}</gj-text>
          <gj-copy-icon :content="row.skuName"></gj-copy-icon>
        </el-row>
        <el-row type="flex">
          <gj-text max-width="90%">{{row.sku | defaultShow}}</gj-text>
          <gj-copy-icon :content="row.sku"></gj-copy-icon>
        </el-row>
      </template>
      <template v-else>
        {{row.marketName | defaultShow}}
      </template>
    </template>
    <template v-slot:msku="{row}">
      <template v-if="row.parent">
        <gj-popover-panel
            v-if="row.marketMskuList && row.marketMskuList.length > 1"
            placement="right"
            :width="'250px'"
            :data="row.marketMskuList">
          <gj-text max-width="90%">{{row.msku | defaultShow}}</gj-text>
        </gj-popover-panel>
        <template v-else>{{row.msku | defaultShow}}</template>
      </template>
      <template v-else>{{row.msku | defaultShow}}</template>
    </template>
    <template v-slot:variationAsin="{row}">
      <gj-link
          v-if="row.variationAsin"
          :href="row.variationAsinUrl"
          target="_blank"
      >{{row.variationAsin | defaultShow}}</gj-link>
      <template v-else>-</template>
    </template>
    <template v-slot:asin="{row}">
      <gj-link :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
      <gj-copy-icon v-if="row.asin" :content="row.asin"/>
    </template>
    <template v-slot:unitsOrdered="{row}">
      <DataClickView @dataClick="handleClickColumn(row, 'unitsOrdered')" :text="row.unitsOrdered | defaultShow"/>
      <!-- <div>{{row.unitsOrdered | defaultShow}}</div> -->
      <div v-if="showTestOrder">{{row.bogusQuantity | defaultShow}}</div>
    </template>
    
    <template v-slot:orders="{row}">
    <DataClickView @dataClick="handleClickColumn(row, 'orders')" :text="row.orders | defaultShow"/>
      <!-- <div>{{row.orders | defaultShow}}</div> -->
      <div v-if="showTestOrder">{{row.bogusOrders | defaultShow}}</div>
    </template>
    <template v-slot:orderProductSales="{row}">
      <DataClickView @dataClick="handleClickColumn(row, 'orderProductSales')" :text="row.orderProductSales | defaultShow(row.currencySymbol)"/>
      <!-- <div>{{row.orderProductSales | defaultShow(row.currencySymbol)}}</div> -->
      <div v-if="showTestOrder">{{row.bogusSalesCost | defaultShow(row.currencySymbol)}}</div>
    </template>
    
    <template v-slot:fulfillableQuantity="{ row }">
      <gj-popover-panel
              title="FBA可售"
              :width="'180px'"
              :data="buildFBA(row)">
        {{ row.fulfillableQuantity | defaultShow }}
      </gj-popover-panel>
    </template>
    <template v-slot:saleableTurnover="{ row }">
      {{ row.saleableTurnover | defaultShow }}
    </template>
    <template v-slot:fulfillableQuantityFBM="{ row }">
      <gj-popover-panel
              title="FBM可售"
              :width="'180px'"
              :data="buildFBM(row)">
        {{ row.fulfillableQuantityFBM | defaultShow }}
      </gj-popover-panel>
    </template>
    <template v-slot:saleableTurnoverFBM="{ row }">
      {{ row.saleableTurnoverFBM | defaultShow }}
    </template>
    <template v-for="(slotName, index) in dynamicSlots" v-slot:[slotName]="{row}">
      <div :key="index">
        <template v-if="showCurrencySymbol">
          <div>{{row[slotName] | defaultShow(row.currencySymbol)}}</div>
          <div v-if="showTestOrder">{{row[`${slotName}-bogus`] | defaultShow(row.currencySymbol)}}</div>
        </template>
        <template v-else>
          <div>{{row[slotName] | defaultShow}}</div>
          <div v-if="showTestOrder">{{row[`${slotName}-bogus`] | defaultShow}}</div>
        </template>
      </div>
    </template>

    <!-- <template v-slot:unitsOrderedB2b="{row}">
      <DataClickView @dataClick="handleClickColumn(row, 'unitsOrderedB2b')" :text="row.unitsOrderedB2b | defaultShow"/>
    </template> -->

    <!-- <template v-slot:orderProductSalesB2b="{row}">
      <DataClickView @dataClick="handleClickColumn(row, 'orderProductSalesB2b')" :text="row.orderProductSalesB2b | defaultShow(row.currencySymbol)"/>
    </template>
    <template v-slot:multiChannelOrders="{row}">
      <DataClickView @dataClick="handleClickColumn(row, 'multiChannelOrders')" :text="row.multiChannelOrders | defaultShow"/>
    </template>
    <template v-slot:returns="{row}">
      <DataClickView @dataClick="handleClickColumn(row, 'returns')" :text="row.returns | defaultShow"/>
    </template>
    <template v-slot:returnsRate="{row}">
      <DataClickView @dataClick="handleClickColumn(row, 'returnsRate')" :text="row.returnsRate | defaultShow('','%')"/>
    </template>
    <template v-slot:refunds="{row}">
      <DataClickView @dataClick="handleClickColumn(row, 'refunds')" :text="row.refunds | defaultShow"/>
    </template>
    <template v-slot:refundsRate="{row}">
      <DataClickView @dataClick="handleClickColumn(row, 'refundsRate')" :text="row.refundsRate | defaultShow('','%')"/>
    </template>
    <template v-slot:returnProductSales="{row}">
      <DataClickView @dataClick="handleClickColumn(row, 'returnProductSales')" :text="row.returnProductSales | defaultShow(row.currencySymbol)"/>
    </template>
    <template v-slot:avgOrderItemsSales="{row}">
      <DataClickView @dataClick="handleClickColumn(row, 'avgOrderItemsSales')" :text="row.avgOrderItemsSales | defaultShow(row.currencySymbol)"/>
    </template> -->

    <template v-for="item in loop_fields"  v-slot:[item.field]="{row}">
      <div :key="item.field">
        <DataClickView @dataClick="handleClickColumn(row, item.field)" :text="(row[item.field]) | defaultShow(row[item.prefix],item.suffix)"/>
      </div>
    </template>


  </gj-table>
</template>

<script>
  import OperationAnalysisModal from "modules/sale/listing/modal/operation-analysis-modal";
  import {isMeaningfulMixin} from "@/minxins";
  import {isMeaningful, isMeaningless} from "@/utils/common";
  import {convertToFullDate} from "@/utils/date.util";
  import {trafficTrendInfo} from "@/api/statistics";
  import StatisticsChart from '@/views/modules/statistics/components/statistics-chart';
  import DataClickView from '@/views/modules/statistics/common/analysis/goods-analysis/widget/data-click-view';
  import OperationAnalysisModalNew from "modules/sale/listing/modal/operation-analysis-modal-new";


  export default {
    name: "analysis-table-new",
    props: {
      showSummary: {
        type: Boolean,
        default: false,
      },
      isCurrencyStatistics:{
        type:Boolean,
        default:false
      },
      queryParams: {
        type: Object,
        default: null,
      },
      groupType: String,
      showTestOrder: {
        type: Boolean,
        default: false
      },
      dynamicSlots: {
        default: () => []
      },
      
      showCurrencySymbol: {
        default: false
      },
      params:{
        type: Object,
        default: null,
      },
      loop_fields: {
        default: () => []
      },
    },
    components: {
      // RelateProductComponent,
      StatisticsChart,
      DataClickView
    },
    data(){
      return {
        type:null,
        chartData:[],
        chartLoading:true,
        sessionsGroupType: [
          { field: 'sessionsMobile', label: 'sessions-移动端' },
          { field: 'sessionsBrowser', label: 'sessions-PC端' },
          { field: 'sessions', label: 'sessions-总计' }
        ],
        pvGroupType: [
          { field: 'pageViewsMobile', label: 'PV-移动端' },
          { field: 'pageViewsBrowser', label: 'PV-PC端' },
          { field: 'pv', label: 'PV-总计' }
        ]
      }
    },
    mixins: [isMeaningfulMixin],
    computed: {
      showTotal() {
        if (isMeaningless(this.queryParams)) {
          return false;
        }
        //gaixie Original currency statistics
        let isCurrencyStatistics;
        if(this.isCurrencyStatistics){//原币种是否要统计
          isCurrencyStatistics = true;
        }else {
          isCurrencyStatistics = this.queryParams.currency !== ''
        }
        return isCurrencyStatistics
          || (isMeaningful(this.queryParams.countrys) && this.queryParams.countrys.length === 1)
          || (isMeaningful(this.queryParams.marketIds) && this.queryParams.marketIds.length === 1);
      },
    },
    methods: {
      handRankingChart(row,type){
        if(row.chartData){
          this.type = type;
          this.chartData = row.chartData;
          this.chartLoading = false;
          return
        }
        let param = {
          startStatisticsDate:this.params.startStatisticsDate,
          endStatisticsDate:this.params.endStatisticsDate,
          marketId:row.marketId,
          groupType:'marketId'
        };
        trafficTrendInfo(param).then(res =>{
          row.chartData = res;
          this.type = type;
          this.chartData = res;
          this.chartLoading = false;
        })
      },
      opListingAnalysis() {
        this.$gjCreate(OperationAnalysisModal)
      },
      /**
       * 跳转asin看板
       * @param row
       */
      handleNavigateAsin (row) {
        const params = {
          asinType: this.queryParams.groupType === 'variationAsin' ? 'parent' : 'child',
          asinCode: this.queryParams.groupType === 'variationAsin' ? row.variationAsin : row.asin,
          countryData: {
            countryIds: [row.country], // 国家
            marketIds: [row.marketId], // 店铺
          },
          date: {
            type: 'DAY',
            value: [
              convertToFullDate(this.queryParams.date[0], 'yyyy-MM-dd'),
              convertToFullDate(this.queryParams.date[1], 'yyyy-MM-dd'),
            ]
          }
        };
        if (this.queryParams.groupType === 'variationAsin') {
          // params.asinType = row.parent ? 'parent' : 'child'
          // params.asinCode = row.parent ? row.variationAsin : row.asin
          if (row.parent && row.variationAsin) {
            params.asinType = 'parent'
            params.asinCode = row.variationAsin
          }else {
            params.asinType = 'child'
            params.asinCode = row.asin
          }
        }
        this.$router.push({path: '/statistics/asin-361-analysis', query: {params: JSON.stringify(params)}})
      },
      /**
       * 跳转全店铺看板
       */
      handleNavigateMarket(row) {
        const params = {
          countryData: {
            countryIds: [row.country], // 国家
            marketIds: [row.marketId], // 店铺
          },
          date: {
            type: 'DAY',
            value: this.queryParams.startStatisticsDate && this.queryParams.endStatisticsDate
              ? [this.queryParams.startStatisticsDate, this.queryParams.endStatisticsDate] : []
          }
        };
        this.$router.push({
          path: '/statistics/shop-wide-analysis',
          query: {
            initQuery: true,
            params: JSON.stringify(params)
          }
        })
      },
      /**
       * popover详情
       * @param row
       */
      buildFBA (row) {
        return [
          [
            {label: 'FBA可售', value: row.fulfillableQuantity}
          ],
          [
            {label: '转运中', value: row.reservedTransfers},
            {label: '处理中', value: row.reservedProcessing},
            {label: '小计', value: row.reservedSum, bold: true},
          ],
          [
            {label: '计划入库', value: row.planInboundQuantityFBA},
            {label: '已发货', value: row.alreadyShipQuantity},
            {label: '入库中', value: row.inboundingQuantity},
            {label: '小计', value: row.quantityFBA, bold: true}
          ]
        ]
      },
      /**
       * popover详情
       */
      buildFBM (row) {
        return [
          [
            {label: 'FBM可售', value: row.fulfillableQuantityFBM}
          ],
          [
            {label: '采购量', value: row.purchaseQuantity},
            {label: '已下单', value: row.alreadyOrderQuantity},
            {label: '交货量', value: row.deliveryQuantity},
            {label: '计划入库', value: row.planInboundQuantityFBM},
            {label: '小计', value: row.quantityFBM, bold: true}
          ]
        ]
      },
        /**
       * 显示弹窗
       */
      handleClickColumn(row, field){
        let params =  this.queryParams;

        let groupType = this.groupType;

        this.$gjCreate(OperationAnalysisModalNew,{
        props: {
          params:{
            ...params,
            date:[params.startStatisticsDate,params.endStatisticsDate],
            groupType:'marketId',
            row:row,
            field:field
          }
          
        }
      })

      },
    }
  }
</script>

<style scoped>
  .analysis-icon {
    font-size: 21px;
    color: #1F6EEF;
    cursor: pointer;
  }
  .market-msku-title > span {
    margin-right: 9px;
  }
</style>
